import { GridController, gridTpl } from '../../../../common/grid/grid.controller';
import { EXPORT_FORMAT } from '../../../../common/utils/util.constants';
import {IDS } from '../tasks-action-id.constants'
import * as Actions from '../tasks.actions';
import watch from "redux-watch";
import {GRID_FILTER} from "../../../../common/grid/grid.constants";
import moment from "moment/moment";

class TasksGridController extends GridController {
    constructor($ngRedux, $state, NavigationService, $filter, $mdDialog, $scope, $rootScope, AuthService) {
        super($ngRedux, $state, NavigationService, $filter, $mdDialog);
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$filter = $filter;
        this.AuthService = AuthService;
    }

    $onInit() {
        this.module = 'accreditation';
        this.identifier = IDS.accTasks;
        this.statePath = IDS.accTasksGrid;
        this.filterTemplate = './tasks-grid-filter.html';
        this.title = this.$filter('translate')('ACCREDITATION.TASKS.LIST.TAB');

        this.columns = [
            {title: '#', mapper: null},
            {title: this.$filter('translate')('COMMON.FIELD.TASK_NUMBER'),      mapper: 'task_number'},
            {title: 'Site',                                                     mapper: 'location_name'},
            {title: this.$filter('translate')('COMMON.FIELD.TYPE'),             mapper: 'utaTypeName'},
            {title: this.$filter('translate')('ACCREDITATION.COMMON.SCHEME'),   mapper: 'framework_code'},
            {title: this.$filter('translate')('COMMON.FIELD.ASSIGNEE'),         mapper: 'assignee'},
            {title: 'Evidence',                                                 mapper: 'evidence'},
            {title: this.$filter('translate')('ACCREDITATION.COMMON.REQUIREMENTS'), mapper:  (item) => item.requirementsColumn.length > 50 ? `${item.requirementsColumn.slice(0,50)}...` : item.requirementsColumn},
            {title: this.$filter('translate')('COMMON.DATE.DUE_DATE'),          mapper: 'due_date'},
            {title: this.$filter('translate')('COMMON.FIELD.STATUS'),           mapper: 'status_name'},
        ];
        this.unsubscribe = this.$ngRedux.connect(this.mapState().bind(this), Actions)(this);

        this.isAdmin = this.AuthService.getUser().typeCode === 'adm';
        this.filterActions.isAdmin = this.isAdmin;
        this.filter.my_tasks_only = this.isAdmin ? 0 : 1;
        this.filter.isAdmin = this.isAdmin;

        this.isManager = this.AuthService.isManager();
        this.filterActions.isManager = this.isManager;
        if(!this.isManager && !this.isAdmin) {
            const filteredColumns = this.columns.concat().filter(column => !['utaTypeName'].includes(column.mapper));
            filteredColumns.splice(4,0,{title: this.$filter('translate')('ACCREDITATION.COMMON.DOCUMENT'), mapper: 'descriptionColumn'});
            this.columns = filteredColumns;
            this.filter.task_status = 'isall';
        }

        const $rootScope = this.$rootScope;
        const watchReset = watch(this.$ngRedux.getState, 'accreditation.accTasks.accTasksGrid.reset');
        this.unsubscribeOnReset = this.$ngRedux.subscribe(watchReset(function() {
            $rootScope.$broadcast('SELECT_CASCADE_RESET', 'accreditationTasksFilterForm');
        }));

        this.filter.identifier = this.identifier;
        this.filter.statePath = this.statePath;
        this.dataAction = this.fetchTasksGrid;
        this.exportService = this.fetchTasksGrid;
        this.exportFormats = [EXPORT_FORMAT.find(item => item.format === 'pdf')];

        // this.buttons.unshift({
        //     class: 'btnGridModify',
        //     label: 'Open',
        //     callback: this.onSelect
        // });

        // this.buttons.unshift({
        //     class: 'btnGridInfo',
        //     label: 'Link',
        //     callback: this.onLinkDialog
        // });
        this.fetchTasksGridSchemes().then( () => {
            this.$ngRedux.dispatch({
                type: GRID_FILTER,
                id:   IDS.accTasks,
                path: IDS.accTasksGrid,
                filter: {
                    year_start: moment().year() - 1,
                    year_end: moment().year() + 2,
                }
            });
            this.init();
        });
    }

    $onDestroy() {
        if(this.unsubscribeOnReset)
            this.unsubscribeOnReset();

        this.destroy();
    }

}

TasksGridController.$inject = ['$ngRedux', '$state', 'NavigationService', '$filter', '$mdDialog', '$scope', '$rootScope', 'AuthService'];

export const accTasksGrid = {
    bindings: {
        identifier: '<',
        onSelect: '&',
        // onLinkDialog: '&',
        onReset: '&'
    },
    controller: TasksGridController,
    ...gridTpl
}
